// Logo assets — cropped, transparent PNGs generated from the user-supplied brand image.
// Landscape aspect (plane + UDYOG wordmark): ~3.08 : 1
// Icon (paper plane only): ~1 : 1
const LANDSCAPE_URL = "/brand/udyog-landscape.png";
const ICON_URL = "/brand/udyog-icon.png";
const LANDSCAPE_ASPECT = 724 / 235; // ≈ 3.08

// eslint-disable-next-line no-unused-vars
export function UdyogLogo({ size = 40, showTagline = false, variant = "landscape", className = "" }) {
  // Note: `showTagline` is kept for API compatibility with existing call-sites but is now
  // a no-op — the tagline "BE INDEPENDENT" is baked into the landscape brand image itself.
  const isIcon = variant === "icon" || variant === "square";
  const src = isIcon ? ICON_URL : LANDSCAPE_URL;

  const height = size;
  const width = isIcon ? size : Math.round(size * LANDSCAPE_ASPECT);

  return (
    <div className={`flex items-center ${className}`} data-testid="udyog-logo">
      <img
        src={src}
        alt="Udyog"
        width={width}
        height={height}
        style={{ height, width, objectFit: "contain" }}
        className="select-none drop-shadow-[0_0_18px_rgba(16,185,129,0.35)]"
        draggable={false}
      />
    </div>
  );
}
